import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie';
import { platformIndex } from "../api/index";

Vue.use(Router);

var router = new Router({
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: '首页'
    },
    {
      path: '/home',
      component: () =>
        import(
          '../pages/EleduiExchange/Home.vue'
        ),
    },
    {
      path: '/order',
      component: () =>
        import(
          '../pages/EleduiExchange/OrderPage.vue'
        ),
    },
    {
      path: '/category',
      component: () =>
        import(
          '../pages/EleduiExchange/Category.vue'
        ),
    },
    {
      path: '/owner',
      component: () =>
        import(
          '../pages/EleduiExchange/OwnerPage.vue'
        ),
    }, {
      path: '/owner-phoneNum',
      component: () =>
        import(
          '../pages/EleduiExchange/Owner-PhoneNum.vue'
        ),
    }, {
      path: '/video-productDetail',
      name: 'video-productDetail',
      component: () =>
        import(
          '../pages/EleduiExchange/VideoProductDetail.vue'
        ),
    }, {
      path: '/orderConfirm',
      name: 'orderConfirm',
      component: () =>
        import(
          '../pages/EleduiExchange/OrderConfirm.vue'
        ),
    },
    {
      path: '/orderSuccess',
      name: 'orderSuccess',
      component: () =>
        import(
          '../pages/EleduiExchange/OrderSuccess.vue'
        ),
    },
    {
      path: '/orderDetail',
      name: 'orderDetail',
      component: () =>
        import(
          '../pages/EleduiExchange/OrderDetail.vue'
        ),
    },
    {
      path: '/jiuGongGe',
      name: 'jiuGongGe',
      component: () =>
        import(
          '../pages/EleduiExchange/Game/JiuGongGe.vue'
        ),
    },
    {
      path: '/codeSearch',
      component: () =>
        import(
          '../pages/EquityCode/CodeSearch.vue'
        ),
    },
    {
      path: '/codeExchange',
      component: () =>
        import(
          '../pages/EquityCode/CodeExchangePage.vue'
        ),
    }, {
      path: '/codeOrderConfirm',
      name: 'codeOrderConfirmPage',
      component: () =>
        import(
          '../pages/EquityCode/CodeOrderConfirmPage.vue'
        ),
    }, {
      path: '/codeSuccessfulPage',
      name: 'codeSuccessfulPage',
      component: () =>
        import(
          '../pages/EquityCode/CodeSuccessfulPage.vue'
        ),
    }, {
      path: '/gameHome',
      name: 'luckwheelPage',
      component: () =>
        import(
          '../pages/game/gameHome.vue'
        ),
    }, {
      path: '/luckyWheelHome',
      name: 'luckyWheelPage',
      component: () =>
        import(
          '../pages/game/luckyWheelHome.vue'
        ),
    }



    // 积分购开始
    ,{
      path: '/jiFenGouHome',
      component: () =>
        import(
          '../pages/JiFenGou/Home.vue'
        ),
    },
    {
      path: '/jiFenGouOrder',
      component: () =>
        import(
          '../pages/JiFenGou/OrderPage.vue'
        ),
    },
    {
      path: '/jiFenGouCategory',
      component: () =>
        import(
          '../pages/JiFenGou/Category.vue'
        ),
    },
    {
      path: '/jiFenGouOwner',
      component: () =>
        import(
          '../pages/JiFenGou/OwnerPage.vue'
        ),
    }, {
      path: '/jiFenGouOwner-phoneNum',
      component: () =>
        import(
          '../pages/JiFenGou/Owner-PhoneNum.vue'
        ),
    }, {
      path: '/jiFenGouVideo-productDetail',
      name: 'jiFenGouVideo-productDetail',
      component: () =>
        import(
          '../pages/JiFenGou/VideoProductDetail.vue'
        ),
    }, {
      path: '/jiFenGouOrderConfirm',
      name: 'jiFenGouOrderConfirm',
      component: () =>
        import(
          '../pages/JiFenGou/OrderConfirm.vue'
        ),
    },
    {
      path: '/jiFenGouOrderSuccess',
      name: 'jiFenGouOrderSuccess',
      component: () =>
        import(
          '../pages/JiFenGou/OrderSuccess.vue'
        ),
    },
    {
      path: '/jiFenGouOrderDetail',
      name: 'jiFenGouOrderDetail',
      component: () =>
        import(
          '../pages/JiFenGou/OrderDetail.vue'
        ),
    },
    {
      path: '/jiFenGouJiuGongGe',
      name: 'jiFenGouJiuGongGe',
      component: () =>
        import(
          '../pages/JiFenGou/Game/JiuGongGe.vue'
        ),
    },
// 积分购结束

    , {
      path: '/customerLogin',
      name: 'CustomerLoginPage',
      component: () =>
        import(
          '../pages/CustomerLogin/CustomerLogin.vue'
        ),
    },
    {
      path: '/myPrize',
      name: 'myPrize',
      component: () =>
        import(
          '../pages/EleduiExchange/Game/myPrize.vue'
        ),
    },
    {
      path: '/gameList',
      name: 'gameList',
      component: () =>
        import(
          '../pages/EleduiExchange/Game/gameList.vue'
        ),
    }
  ]
})
export default router;

router.beforeEach((to, from, next) => {
  var path = to.path;
  var flg = false;
  if (path.startsWith("/home")) {
    var merchantId = to.query.merchantId;
    var customerId = to.query.customerId;
    var sign = to.query.sign;
    //如果访问标识为空则需要调用远程接口
    if (Cookies.get('access') == null || sign != null) {
      if (merchantId == null || customerId == null || sign == null) {
        next("404");
        return;
      }
      const data = {
        merchantId: merchantId,
        customerId: customerId,
        sign: sign
      };
      platformIndex(data).then(res => {
        const { data } = res;
        if (data.code == "0") {
          var merchantInfo = data.data;
          merchantInfo.balance = data.ext.balance;
          merchantInfo.creditName = data.ext.creditName;
          Cookies.set('access', merchantInfo);
          window.sessionStorage.setItem("login_info", { merchantId: merchantId, customerId, sign });
          flg = true;
          next(true);
        } else {
          next("404");
        }
      });
    } else {
      var merchantInfo = Cookies.get('access');
      next(true);
    }
  } else {
    next(true);
  }
});


// WEBPACK FOOTER //
// ./src/router/index.js